export const storeModule = {
  address: "店舗住所",
  baseInfo: "基本情報",
  content: "内容",
  time: "営業時間",
  pickTime: "テイクアウト時間",
  devTime: "配達対応時間",
  dateTime: "営業曜日",
  payFun: "お支払方法",
  detail: "店舗詳細",
  detailInfo: "店舗紹介",
  devPrice: "送料",
  minPrice: "最低注文金額",
  freePrice: "* 以上送料無料",
  freeDevPriceDiff: "あと*で無料配達！",
  freeDevPrice: "送料無料",
  leal: "特商法",
  lealTab1: "項目",
  lealTab2: "記入欄",
  lealTitle1: "販売事業者名(社名・商号・屋号)",
  lealTitle2: "販売事業者所在地",
  lealTitle3: "代表者または運営統括責任者",
  lealTitle4: "代表者または運営統括責任者（フリガナ）",
  lealTitle5: "連絡先/ホームページ",
  lealTitle6: "連絡先/電子メール",
  lealTitle7: "連絡先/TEL",
  lealTitle8: "販売価格帯",
  lealTitle9: "商品等の引き渡し時期・発送方法",
  lealTitle10: "代金の支払時期および方法",
  lealTitle11: "商品代金以外に必要な費用/送料、手数料、消費税等",
  lealTitle12:
    "返品の取扱条件/返品期限、返品時の送料負担送料または中途解約や退会条件",
  lealTitle13: "不良品の取扱条件",
  shopTimeOuter1: "受付休止中",
  shopTimeOuter2: "受付時間外",
  shopTimeOuterSm1: "準備中",//休止中
  shopTimeOuterSm2: "時間外",
  orderSm1: "予約可",
  orderDayBefore: "*日前",
  noText: "なし",
  storeRemark: "店舗一言",
  devDistanceNo: "お届先が当店の配達範囲外です。別の店舗をお探しください",
  devSearch: "再検索",
  devNoAddress: "下記の三つから選択して下さい"
};
export const evaluationModule = {
  star: "満足度",
  contentHolder: "コメントをどうぞご入力ください",
  noStar: "満足度をご選択ください",
  noContent: "どうぞコメントしてくださいコメントする",
  submitSuccess: "コメントしました",
  replay: "店舗回答",
  uploadSuccess: "アップロードしました"
};
